import React from "react";
import TaskItem, { TaskDetail } from "./TaskItem";

export interface StartedProcess extends TaskDetail {
  idprocess: number;
  process_description: string;
  process_enddate: string | null;
  process_startdate: string | null;
  process_idprocessmodel: number;
  process_userdata: string;
  processduration: number;
  // tasks: Array<TaskDetail>;
}

interface ProcessItemProps {
  process: StartedProcess;
  lastElementRef?: (node: any) => void;
  filters: Record<string, any>;
  refresh: () => void;
}
const ProcessItem: React.FC<ProcessItemProps> = ({
  process,
  filters,
  lastElementRef,
  refresh,
}) => {
  return (
    <React.Fragment>
      <TaskItem
        key={`task-in-processes-${process.idprocesstoken}`}
        process={process}
        filters={filters}
        lastElementRef={lastElementRef}
        task={process}
        refresh={refresh}
      />
      {/* <ListItemButton
        sx={{ alignItems: "center", display: "flex", flexDirection: "row" }}
        onClick={() => setOpen((_) => !_)}
      >
        <ListItemText
          sx={{ flex: 1 }}
          primaryTypographyProps={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            maxWidth: "calc(100vw - 50vw)",
          }}
          secondary={!process.process_startdate ? '' : `started at ${formatDate(process.process_startdate)}`}
          primary={process.process_description}
        />
        {shouldExpand && (!open ? <ExpandMore /> : <ExpandLess />)}
      </ListItemButton>
      {shouldExpand && (
        <Collapse unmountOnExit mountOnEnter in={open}>
          <List sx={{ pl: 2 }}>
            {process.tasks.map((task) => (
              <TaskItem key={task.id} task={task} />
            ))}
          </List>
        </Collapse>
      )}
      <Divider /> */}
    </React.Fragment>
  );
};

export default ProcessItem;
